// extracted by mini-css-extract-plugin
export var boldText = "_3d-4";
export var checkboxContainer = "_3d-6";
export var closeIcon = "_3d-g";
export var container = "_3d-0";
export var drawer = "_3d-8";
export var drawerContent = "_3d-9";
export var extraSmallText = "_3d-5";
export var fulfillmentGroupTable = "_3d-e";
export var largeText = "_3d-3";
export var loadingSpinnerContainer = "_3d-h";
export var mediumText = "_3d-2";
export var narrow = "_3d-f";
export var notificationLink = "_3d-j";
export var packageCheckIconContainer = "_3d-7";
export var slideoutHeaderContainer = "_3d-a";
export var slideoutModal = "_3d-c";
export var stickyHeaderWrapper = "_3d-b";
export var table = "_3d-i";
export var tableContainer = "_3d-d";
export var tertiaryText = "_3d-1";